import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PARTNER_LINK_KEY = 'partnerLink';

export const PartnerLinkHandler = () => {
  const location = useLocation();

  const isValidDate = (dateStr) => {
    const linkDate = dateStr.slice(-6);
    
    if (linkDate.length !== 6) return false;
    
    const year = '20' + linkDate.slice(0, 2);
    const month = linkDate.slice(2, 4);
    const day = linkDate.slice(4, 6);
    
    const linkDateTime = new Date(year, parseInt(month) - 1, day);
    const today = new Date();
    
    if (isNaN(linkDateTime.getTime())) return false;
    
    today.setHours(0, 0, 0, 0);
    linkDateTime.setHours(0, 0, 0, 0);
    
    const diffTime = linkDateTime.getTime() - today.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    
    return diffDays <= 0;
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const incomingLink = searchParams.get('partner');
    const hasStoredLink = localStorage.getItem(PARTNER_LINK_KEY) !== null;

    // 파트너스 링크 파라미터가 없을 때
    if (!incomingLink) {
      // 저장된 링크가 있다면 삭제
      if (hasStoredLink) {
        localStorage.removeItem(PARTNER_LINK_KEY);
        
      }
      return;
    }

    // 파트너스 링크 파라미터가 있을 때의 처리
    if (incomingLink.length < 7) {
      
      return;
    }

    if (!isValidDate(incomingLink)) {
      
      return;
    }

    const currentStoredLink = localStorage.getItem(PARTNER_LINK_KEY);
    
    if (currentStoredLink !== incomingLink) {
      localStorage.setItem(PARTNER_LINK_KEY, incomingLink);
      
    }
  }, [location.search]);

  return null;
};

export default PartnerLinkHandler;